import { render, staticRenderFns } from "./getProductView.vue?vue&type=template&id=66a50dea&scoped=true&"
import script from "./getProductView.vue?vue&type=script&lang=js&"
export * from "./getProductView.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a50dea",
  null
  
)

export default component.exports